// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"843586d6","453":"94245784"}[chunkId] + ".chunk.js";
};